export default {
  colors: {
    primary: '#2B3545',
    background: '#FFFFFF',
    sidebar: {
			background: '#2B3545',
			link: '#59E596',
			heading: '#FFFFFF',
			linkActive: '#2B3545',
			itemActive: '#59E596',
			footer: '#A8A8B3',
    },
    postnav: {
      background: '#2B3545',
      backgroundAlternative: '#59E596',
      link: '#59E596',
      linkAlternative: '#2B3545',
      title: '#FFFFFF',
      outline: ' #4d4d4d',
      backgroundActive: '#59E596',
      linkActive: '#2B3545',
      outlineActive: '#91989c',
    },
  },
};